/* global $, data, queryString, yearSettings */
/* eslint-disable no-param-reassign */
import Table from 'bam-node-savant-table/table'

import '../bower_components/tablesorter/jquery.tablesorter.min' // eslint-disable-line
import './tablesorter-widget'
import { guff } from 'bam-node-baseball-savant/utils/guff'

const params = new URLSearchParams(window.location.search)
const allDiffs = params.get('allDiffs') === '1'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'parkFactors'

loadDropdowns()

// Global table variable
let t

if (data) {
    data.map((d) => {
        d.href = `<a href="/leaderboard/statcast-venue?venueId=${d.venue_id}">${d.venue_name}</a>`
        return d
    })
    const headers = getHeaders($('#ddlType').val())
    const secondaryHeaders = getSecondaryHeaders()

    if ($('#ddlRoll').val() === '' && $('#ddlType').val() === 'year') {
        headers.splice(5, 1)
        headers.splice(6, 2)
    }

    const width = $(`#${tableDivId}`).outerWidth()
    let repeatHeaders = false
    if (width <= 768) {
        repeatHeaders = 15
    }

    let defaultSort =
        headers[Number($('#sort').val())].customSortField ||
        headers[Number($('#sort').val())].field

    if (queryString.type === 'dimensions') {
        defaultSort =
            queryString.fenceStatType === 'height'
                ? 'avg_fence_height'
                : 'avg_fence_distance'
    }

    const initialSortDirection = $('#sortDir').val()

    t = new Table({
        id: tableDivId,
        repeatHeader: repeatHeaders,
        headers,
        secondaryHeaders,
        data,
        showRank: true,
        defaultSort,
        initialSortDirection,
        sortClass: 'column-sort',
        subDataId: 'venue_id',
    })
}

$(document).ready(() => {
    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })

    $('#ddlType').change(() => {
        $('#lblType').html(`FACTOR: ${$('#ddlType option:selected').text()}`)

        updateYearDropdown()

        hideDropdowns()
    })

    $('#ddlCondition').change(() => {
        $('#lblCondition').html(
            `Condition: ${$('#ddlCondition option:selected').text()}`
        )
    })

    $('#ddlStat').change(() => {
        $('#lblStat').html(`Stat: ${$('#ddlStat option:selected').text()}`)
    })

    $('#ddlRoll').change(() => {
        $('#lblRoll').html(
            `Rolling Years: ${$('#ddlRoll option:selected').text()}`
        )
        updateYearDropdown()
    })

    $('#ddlBatSide').change(() => {
        $('#lblBatSide').html(
            `Bat Side: ${$('#ddlBatSide option:selected').text()}`
        )
    })

    $('#ddlParks').change(() => {
        $('#lblParks').html(`Parks: ${$('#ddlParks option:selected').text()}`)
    })
})

function updateYearDropdown() {
    let year = $('#ddlSeason').val()

    const type = $('#ddlType').val()
    if (type === 'dimensions') {
        $('#ddlSeason').empty()
        yearSettings.dimensionYears.forEach((y) => {
            $('#ddlSeason').append($('<option></option>').val(y).text(y))
        })
        if (Number(year) >= 2015) {
            $('#ddlSeason').val(String(year))
        } else {
            year = yearSettings.year
            $('#ddlSeason').val(String(year))
        }
    } else if (type === 'distance') {
        $('#ddlSeason').empty()
        yearSettings.statcastyYears.forEach((y) => {
            $('#ddlSeason').append($('<option></option>').val(y).text(y))
        })
        if (Number(year) > 2015) {
            $('#ddlSeason').val(String(year))
        } else {
            year = yearSettings.year
            $('#ddlSeason').val(String(year))
        }
    } else {
        $('#ddlSeason').empty()
        yearSettings.years.forEach((y) => {
            $('#ddlSeason').append($('<option></option>').val(y).text(y))
        })
        $('#ddlSeason').val(String(year))
    }

    $('#lblSeason').html(year)
}

function hideDropdowns() {
    const type = $('#ddlType').val()
    if (type === 'distance' || type === 'dimensions') {
        $('#season-container').show()
        $('#roll-container').hide()
        $('#stat-container').hide()
        $('#condition-container').hide()
        $('#batside-container').hide()
        $('#park-filter-container').hide()
    } else if (type === 'distance-all') {
        $('#season-container').hide()
        $('#roll-container').hide()
        $('#stat-container').hide()
        $('#condition-container').hide()
        $('#batside-container').hide()
        $('#park-filter-container').show()
    } else if (type === 'venue') {
        $('#season-container').hide()
        $('#roll-container').show()
        $('#stat-container').show()
        $('#condition-container').show()
        $('#batside-container').show()
        $('#park-filter-container').show()
    } else if (type === 'raw') {
        $('#season-container').show()
        $('#roll-container').hide()
        $('#stat-container').hide()
        $('#condition-container').hide()
        $('#batside-container').show()
        $('#park-filter-container').hide()
    } else {
        $('#season-container').show()
        $('#roll-container').show()
        $('#stat-container').hide()
        $('#condition-container').show()
        $('#batside-container').show()
        $('#park-filter-container').show()
    }

    if (type === 'dimensions') {
        $('#fence-stat-container').show()
    } else {
        $('#fence-stat-container').hide()
    }
}

$(document).on('click', 'th.th-component-header', function clickHandler() {
    const id = this.id.split('-')[1]
    if (Number($('#sort').val()) === Number(id)) {
        if ($('#sortDir').val() === 'desc') {
            $('#sortDir').val('asc')
        } else {
            $('#sortDir').val('desc')
        }
    } else {
        $('#sortDir').val('desc')
    }
    $('#sort').val(id)
    checkHeaderPosition(tableDivId)
    updateUrl()
})

$('#btnUpdate').click(() => {
    window.location = getUrl(false)
    return false
})

function updateUrl() {
    const url = getUrl()

    window.history.pushState('', '', url)
    return url
}

function getUrl(appendSort = true) {
    const type = $('#ddlType').val()
    let url = `/leaderboard/statcast-park-factors?type=${type}&year=${$(
        '#ddlSeason'
    ).val()}&batSide=${$('#ddlBatSide').val()}&stat=${$(
        '#ddlStat'
    ).val()}&condition=${$('#ddlCondition').val()}&rolling=${$(
        '#ddlRoll'
    ).val()}&parks=${$('#ddlParks').val()}`

    if ($('#ddlRoll').val() === '') {
        // Only append sort when it's toggled through sorting... else ignore
        if (appendSort) {
            url += `&sort=${$('#sort').val()}&sortDir=${$('#sortDir').val()}`
        }
    }

    if (type === 'dimensions') {
        url += `&fenceStatType=${$('#ddlFenceStatType').val()}`

        if (allDiffs) {
            url += '&allDiffs=1'
        }
    }

    return url
}

window.addEventListener('scroll', () => {
    if (!ticking && data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId, isFixedHeaderShowing)
            ticking = false
        })

        ticking = true
    }
})

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (width && width > 767) {
        // console.log(width);
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $('.default-table-row')
            .first()
            .children('td')
            .each(function eachHandler() {
                const rowWidth = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    rowWidth
                )
                tableCell += 1
            })

        $(`#${divId} table thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $('.tr-component-row')
            .children('th')
            .each(function eachHandler() {
                const rowWidth = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    rowWidth
                )
                tableCell += 1
            })
    }
}

function loadDropdowns() {
    if (queryString.type) {
        $('#ddlType').val(queryString.type).attr('selected', true)
        $('#lblType').html(`FACTOR: ${$('#ddlType option:selected').text()}`)
    }

    if (queryString.year) {
        $('#ddlSeason').val(queryString.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (queryString.condition) {
        $('#ddlCondition').val(queryString.condition).attr('selected', true)
        $('#lblCondition').html(
            `Condition: ${$('#ddlCondition option:selected').text()}`
        )
    }

    if (queryString.rolling) {
        $('#ddlRoll').val(queryString.rolling).attr('selected', true)
        $('#lblRoll').html(
            `Rolling Years: ${$('#ddlRoll option:selected').text()}`
        )
    }

    if (queryString.batSide) {
        $('#ddlBatSide').val(queryString.batSide).attr('selected', true)
        $('#lblBatSide').html(
            `Bat Side: ${$('#ddlBatSide option:selected').text()}`
        )
    }

    if (queryString.stat) {
        $('#ddlStat').val(queryString.stat).attr('selected', true)
        $('#lblStat').html(`Stat: ${$('#ddlStat option:selected').text()}`)
    }

    if (queryString.parks) {
        $('#ddlParks').val(queryString.parks).attr('selected', true)
        $('#lblParks').html(`Parks: ${$('#ddlParks option:selected').text()}`)
    }

    if (queryString.sortDir) {
        $('#sortDir').val(queryString.sortDir)
    }

    if (queryString.sort) {
        $('#sort').val(queryString.sort)
    }
    hideDropdowns()
}

function getSecondaryHeaders() {
    if ($('#ddlType').val() === 'distance') {
        return [
            {
                name: '',
                colspan: 3,
                headerClass: 'th-name-header',
            },
            {
                name: 'Variable Extra Distance',
                colspan: 5,
                headerClass: 'th-title-header',
            },
        ]
    }
    if ($('#ddlType').val() === 'distance-all') {
        return [
            {
                name: '',
                colspan: 3,
                headerClass: 'th-name-header',
            },
            {
                name: 'Variable Extra Distance',
                colspan: yearSettings.statcastyYears.length,
                headerClass: 'th-title-header',
            },
        ]
    }
    if ($('#ddlType').val() === 'raw') {
        return [
            {
                name: '',
                colspan: 4,
                headerClass: 'th-name-header',
            },
            {
                name: 'This Park',
                colspan: 9,
                headerClass: 'th-title-header',
            },
            {
                name: 'Other Parks',
                colspan: 9,
                headerClass: 'th-title-header',
            },
        ]
    }

    if ($('#ddlType').val() === 'dimensions') {
        return [
            {
                name: '',
                colspan: 4,
                headerClass: 'th-name-header',
            },
            {
                name: '<span class="venue-info-secondary-dist">Distance (feet)</span><span class="venue-info-secondary-height">Height (feet)</span>',
                colspan: 6,
                headerClass: 'th-title-header border-left',
            },
            {
                name: '',
                colspan: 4,
                headerClass: 'th-title-header border-left',
            },
        ]
    }
    return []
}

function diffFn(val, row, { field }) {
    const expectChanges = allDiffs || row.is_diff_configuration
    const rawDiff = row[`${field}_diff`]
    const diff = Math.round(row[`${field}_diff`])
    if (Math.abs(rawDiff) >= 1 && expectChanges) {
        const diffColor = diff > 0 ? '#D82129' : '#3661AD'
        const formattedVal = guff(val, 'venue_fence_distance')
        const formattedDiff = guff(diff, 'venue_fence_distance', {
            isDiff: true,
        })
        return `${formattedVal} <span style="color: ${diffColor}; font-size: 0.8rem;">(${formattedDiff})</span>`
    }

    return Math.round(val)
}

function diffHeightFn(val, row, { field }) {
    const diff = Number(row[`${field}_diff`])
    const formattedVal = guff(val, 'venue_fence_height')

    if (!diff) {
        return formattedVal
    }

    const expectChanges = allDiffs || row.is_diff_configuration
    if (Math.abs(diff) >= 1 && expectChanges) {
        const diffColor = diff > 0 ? '#D82129' : '#3661AD'
        const formattedDiff = guff(diff, 'venue_fence_height', { isDiff: true })
        return `${formattedVal} <span style="color: ${diffColor}; font-size: 0.8rem;">(${formattedDiff})</span>`
    }

    return formattedVal
}

function sqFtDiffFn(val, row, { field }) {
    const formattedVal = guff(val, 'venue_square_footage')
    const expectChanges = allDiffs || row.is_diff_configuration
    const diff = Math.round(row[`${field}_diff`])
    const prev = val - diff
    const percentDiff = diff / prev
    if (diff && Math.abs(percentDiff) > 0.005 && expectChanges) {
        const diffColor = diff > 0 ? '#D82129' : '#3661AD'
        const percentDiffFormatted = guff(
            percentDiff,
            'venue_square_footage_diff',
            {
                isDiff: true,
            }
        )

        return `${formattedVal} <span style="color: ${diffColor}; font-size: 0.8rem;">(${percentDiffFormatted})</span>`
    }

    return formattedVal
}

function getHeaders(type) {
    if (type === 'distance') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]
        const highlightRange = [0, -10, -10, 0, 10, 10]
        return [
            {
                name: 'Team',
                field: 'name_display_club',
                customSortField: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'"/>`,
                photoId: 'main_team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                customSortField: 'venue_name',
                headerClass: 'th-component-header align-left border-right',
                fieldClass: 'tr-data align-left border-right venue-link',
            },
            {
                name: 'Total',
                field: 'extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
                displayFn: (val) => Number(val).toFixed(1),
            },
            {
                name: 'Temp',
                field: 'temperature_extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
                displayFn: (val) => Number(val).toFixed(1),
            },
            {
                name: 'Elev',
                field: 'elevation_extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
                displayFn: (val) => Number(val).toFixed(1),
            },
            {
                name: 'Env',
                field: 'environment_extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
                displayFn: (val) => Number(val).toFixed(1),
            },
            {
                name: 'Roof',
                field: 'roof_extra_distance',
                headerClass: 'th-component-header align-right border-right',
                fieldClass: 'tr-data align-right border-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
            },
            {
                name: 'Avg Temp',
                field: 'avg_temperature',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
                displayFn: (val) => Number(val).toFixed(1),
            },
            {
                name: 'Elev',
                field: 'elevation_feet',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'Roof %',
                field: 'avg_roof',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
            {
                name: 'Day %',
                field: 'avg_daytime',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
        ]
    }
    if (type === 'distance-all') {
        const highlightColors = [
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]

        const headers = [
            {
                name: 'Team',
                field: 'name_display_club',
                customSortField: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                customSortField: 'venue_name',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left venue-link',
            },
        ]
        for (let y = yearSettings.year; y > 2015; y--) {
            let border = ``
            if (y === yearSettings.year) {
                border = `border-left`
            }
            if (y === 2016) {
                border = `border-right`
            }

            headers.push({
                name: String(y),
                field: `extra_distance_${y}`,
                headerClass: `th-component-header align-right ${border}`,
                fieldClass: `tr-data align-right ${border}`,
                highlight: [-500, -10, 0, 10, 500],
                highlightColors,
                type: 'number',
                displayFn: (val) =>
                    ['', null, undefined].includes(val)
                        ? ''
                        : Number(val).toFixed(1),
            })
        }
        return headers
    }
    if (type === 'venue') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]

        const headers = [
            {
                name: 'Team',
                field: 'name_display_club',
                customSortField: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                customSortField: 'venue_name',

                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left venue-link',
            },
        ]
        for (let y = yearSettings.year; y > 1998; y--) {
            headers.push({
                name: String(y),
                field: `metric_value_${y}`,
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: [0, 80, 90, 100, 110, 500],
                highlightColors,
                type: 'number',
            })
        }
        return headers
    }
    if (type === 'year') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]
        const highlightRange = [0, 80, 90, 100, 110, 300]
        return [
            {
                name: 'Team',
                field: 'name_display_club',
                customSortField: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                customSortField: 'venue_name',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left venue-link',
            },
            {
                name: 'Year',
                field: 'year_range',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'Park Factor',
                field: 'index_woba',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'wOBAcon',
                field: 'index_wobacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'xwOBAcon',
                field: 'index_xwobacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'BACON',
                field: 'index_bacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'xBACON',
                field: 'index_xbacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'HardHit',
                field: 'index_hardhit',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'R',
                field: 'index_runs',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'OBP',
                field: 'index_obp',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'H',
                field: 'index_hits',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: '1B',
                field: 'index_1b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: '2B',
                field: 'index_2b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: '3B',
                field: 'index_3b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'HR',
                field: 'index_hr',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'BB',
                field: 'index_bb',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'SO',
                field: 'index_so',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'PA',
                field: 'n_pa',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
                displayFn: (val) => (val ? Number(val).toLocaleString() : val),
            },
        ]
    }
    if (type === 'raw') {
        return [
            {
                name: 'Team',
                field: 'name_display_club',
                customSortField: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'" />`,
                photoId: 'team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                customSortField: 'venue_name',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left venue-link',
            },
            {
                name: 'Year',
                field: 'year',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'Batted Balls',
                field: 'n_hip',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'H',
                field: 'n_hits',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: '1B',
                field: 'n_1b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: '2B',
                field: 'n_2b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: '3B',
                field: 'n_3b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'HR',
                field: 'n_hr',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'BB',
                field: 'n_bb',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'SO',
                field: 'n_so',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'PA',
                field: 'n_pa',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'Batted Balls',
                field: 'otherpark_n_hip',
                type: 'number',
                headerClass: 'th-component-header align-right border-left',
                fieldClass: 'tr-data align-right border-left',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'H',
                field: 'otherpark_hits',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: '1B',
                field: 'otherpark_1b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: '2B',
                field: 'otherpark_2b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: '3B',
                field: 'otherpark_3b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'HR',
                field: 'otherpark_hr',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'BB',
                field: 'otherpark_bb',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'SO',
                field: 'otherpark_so',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'PA',
                field: 'otherpark_n_pa',
                headerClass: 'th-component-header align-right border-right',
                fieldClass: 'tr-data align-right border-right',
                type: 'number',
                displayFn: (val) => Number(val).toLocaleString(),
            },
        ]
    }

    if (type === 'dimensions') {
        return [
            {
                name: 'Team',
                field: 'name_display_club',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
                displayFn: (val, { team_id, season_id }) => {
                    const url = team_id
                        ? `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/${team_id}.svg" onerror="this.onerror='';this.src='https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'"/>`
                        : `<img class="table-team-logo" src="https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg">`

                    const link = team_id
                        ? `<a href="/team/${team_id}?season=${season_id}">${val}</a>`
                        : '--'
                    return `${url} ${link}`
                },
            },
            {
                name: 'Venue',
                field: 'venue_name_short',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                displayFn: (val, { venue_id }) =>
                    `<a href="/leaderboard/statcast-venue?venueId=${venue_id}">${val}</a>`,
            },
            {
                name: 'Season',
                field: 'season_id',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                type: 'number',
            },
            {
                name: 'LF Line',
                field: 'distance_lf_line',
                headerClass: 'th-component-header venue-info-dist-col',
                fieldClass: 'tr-data venue-info-dist-col',
                type: 'number',
                displayFn: diffFn,
            },
            {
                name: 'LF Gap',
                field: 'distance_lf_gap',
                headerClass: 'th-component-header venue-info-dist-col',
                fieldClass: 'tr-data venue-info-dist-col',
                type: 'number',
                displayFn: diffFn,
            },
            {
                name: 'CF',
                field: 'distance_cf',
                headerClass: 'th-component-header venue-info-dist-col',
                fieldClass: 'tr-data venue-info-dist-col',
                type: 'number',
                displayFn: diffFn,
            },
            {
                name: 'RF Gap',
                field: 'distance_rf_gap',
                headerClass: 'th-component-header venue-info-dist-col',
                fieldClass: 'tr-data venue-info-dist-col',
                type: 'number',
                displayFn: diffFn,
            },
            {
                name: 'RF Line',
                field: 'distance_rf_line',
                headerClass: 'th-component-header venue-info-dist-col',
                fieldClass: 'tr-data venue-info-dist-col',
                type: 'number',
                displayFn: diffFn,
            },
            {
                name: 'Deepest<br/>Point',
                field: 'distance_deepest',
                headerClass:
                    'th-component-header venue-info-dist-col border-right dashed-left',
                fieldClass:
                    'tr-data venue-info-dist-col border-right dashed-left',
                type: 'number',
                displayFn: diffFn,
                toolTip:
                    '<div style="white-space: wrap; width: 250px;">Deepest point of park. May or may not be one of 5 standard points displayed.</div>',
            },
            {
                name: 'LF Line',
                field: 'height_lf_line',
                headerClass: 'th-component-header venue-info-height-col',
                fieldClass: 'tr-data venue-info-height-col',
                type: 'number',
                displayFn: diffHeightFn,
            },
            {
                name: 'LF Gap',
                field: 'height_lf_gap',
                headerClass: 'th-component-header venue-info-height-col',
                fieldClass: 'tr-data venue-info-height-col',
                type: 'number',
                displayFn: diffHeightFn,
            },
            {
                name: 'CF',
                field: 'height_cf',
                headerClass: 'th-component-header venue-info-height-col',
                fieldClass: 'tr-data venue-info-height-col',
                type: 'number',
                displayFn: diffHeightFn,
            },
            {
                name: 'RF Gap',
                field: 'height_rf_gap',
                headerClass: 'th-component-header venue-info-height-col',
                fieldClass: 'tr-data venue-info-height-col',
                type: 'number',
                displayFn: diffHeightFn,
            },
            {
                name: 'RF Line',
                field: 'height_rf_line',
                headerClass: 'th-component-header venue-info-height-col',
                fieldClass: 'tr-data venue-info-height-col',
                type: 'number',
                displayFn: diffHeightFn,
            },
            {
                name: 'Highest<br/>Point',
                field: 'height_highest',
                headerClass:
                    'th-component-header venue-info-height-col border-right dashed-left',
                fieldClass:
                    'tr-data venue-info-height-col border-right dashed-left',
                type: 'number',
                displayFn: diffHeightFn,
                toolTip:
                    '<div style="white-space: wrap; width: 250px;">Highest height of the fence. May or may not be one of 5 standard points displayed.</div>',
            },
            {
                name: 'Playing Field<br/>Area (sq. ft.)',
                field: 'fence_area',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: sqFtDiffFn,
                toolTip: 'Fair Territory Only',
            },
            {
                name: 'Avg. Fence <br/> Distance',
                field: 'avg_fence_distance',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: diffFn,
            },
            {
                name: 'Avg. Fence <br/>Height',
                field: 'avg_fence_height',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) => Number(val).toFixed(1),
            },
            {
                name: 'Avg. HR',
                field: 'avg_hr_distance',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                type: 'number',
                displayFn: diffFn,
                toolTip:
                    '<div style="white-space: wrap">Estimated by averaging the (fence distance + fence height) throughout the entire outfield.</div>',
            },
        ]
    }

    return []
}

function handleTableRefresh(newHeaders) {
    t.currentSortColumn = newHeaders
    t.refreshTable()
}

document
    .getElementById('ddlFenceStatType')
    .addEventListener('change', ({ target: { value } }) => {
        const newHeaders = t.currentSortColumn.map((d) => {
            if (value === 'height' && d.field.includes('distance_')) {
                return { ...d, field: d.field.replace('distance_', 'height_') }
            }
            if (value === 'distance' && d.field.includes('height_')) {
                return { ...d, field: d.field.replace('height_', 'distance_') }
            }
            return { ...d }
        })

        if (value === 'distance') {
            document
                .querySelector('.table-savant')
                .classList.remove('show-height')
        } else {
            document.querySelector('.table-savant').classList.add('show-height')
        }

        handleTableRefresh(newHeaders)

        const url = new URL(window.location)
        url.searchParams.set('fenceStatType', value)

        window.history.replaceState('', '', String(url))
    })
